import {simpleCard} from '@img/index.js'
import {parseCard} from '@/utils/functions'

/*
 * `disabled` = not clickable. `dimmed` = not clickable BECAUSE a policy blocks it.
 *
 * They were one flag, and `opacity-60` rode on it — so /rides/:id/view, where nothing is
 * blocked and there is simply nothing to pick, washed the selected row's mint out to a
 * pale tint with grey text. Same distinction DateTimeCard already draws for readOnly.
 */
export default function CardRow({card, isSelected, onSelect, disabled, dimmed = false}) {
    const {brand, last4} = parseCard(card)
    return (
        <button type="button" disabled={disabled} onClick={() => !disabled && onSelect(card.id)}
                className={`w-full flex items-center gap-3 p-3.5 rounded-[16px] border-0 text-left transition-colors ${isSelected ? 'bg-(--accent-green-light)' : 'bg-(--bg-grey)'} ${dimmed ? 'cursor-not-allowed opacity-60' : disabled ? 'cursor-default' : 'cursor-pointer'}`}>
            <span className="w-10 h-10 rounded-xl bg-white flex items-center justify-center shrink-0">
                <img src={simpleCard} alt="" className="w-5"/>
            </span>
            <span className="flex-1 min-w-0 font-semibold text-sm truncate">{brand || 'Card'}****{last4 || '****'}</span>
            <span className="w-4.5 h-4.5 shrink-0 flex items-center justify-center border border-(--text-primary) rounded">
                {isSelected && <span className="w-2 h-2 bg-(--text-primary)"/>}
            </span>
        </button>
    )
}
